import { Box, Chip, Typography } from '@mui/material';
import React from 'react';
import { themeColorsDark } from '../../JuvareTheme/colors/themeColorsDark';
import { useCommonWebTranslation } from '../../hooks';
export const Title = ({ appTitle, environment, environmentLabel }) => {
    const { t } = useCommonWebTranslation();
    return (React.createElement(Box, { component: 'div', sx: {
            flexGrow: 1,
            mr: 1,
            display: 'flex',
            alignItems: 'center',
            overflow: 'hidden',
        } },
        React.createElement(Typography, { variant: 'body1', sx: {
                fontSize: '20px',
                fontWeight: 500,
                lineHeight: '28px',
                letterSpacing: '0.15px',
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
            } }, appTitle),
        environment && (React.createElement(Chip, { size: 'small', label: environmentLabel !== null && environmentLabel !== void 0 ? environmentLabel : t(`globalHeader.environment.${environment}`), sx: {
                ml: 1,
                color: chipTextColors[environment],
                backgroundColor: chipBackgroundColors[environment],
                textTransform: 'uppercase',
            } }))));
};
const chipBackgroundColors = {
    // Global App header is always dark.
    local: themeColorsDark.decorative.blue,
    dev: themeColorsDark.decorative.green,
    lab: themeColorsDark.decorative.orange,
    demo: themeColorsDark.decorative.red,
};
const chipTextColors = {
    // Global App header is always dark.
    local: themeColorsDark.decorative.white,
    dev: themeColorsDark.decorative.white,
    lab: themeColorsDark.decorative.white,
    demo: themeColorsDark.decorative.white,
};
